import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css";

import { Link } from "react-router-dom";
export default function PressureServicelevage() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
      <Header />

      <main className="prs">
        {/* ===== HERO court ===== */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Contrôle des Appareils de Levage</h1>
            <p>
              Vérification réglementaire des équipements de levage pour assurer la
              sécurité, la conformité et la continuité d’exploitation de vos installations.
            </p>

            <a href="#contact" className="btn-primary">
              Demander un devis
            </a>
          </div>

          <div className="prs-hero__slider">
            <Slider {...sliderSettings}>
              <div><img src="/images/levage/1.jpeg" alt="Inspection en atelier" /></div>
              <div><img src="/images/levage/2.jpg" alt="Essai statique" /></div>
              <div><img src="/images/levage/3.jpg" alt="Appareil de levage" /></div>
              <div><img src="/images/levage/6.jpg" alt="Contrôle visuel" /></div>
            </Slider>
          </div>
        </section>

        {/* ===== SECTION RÉGLEMENTATION ===== */}
        <section className="prs-reglement">
          <h2>Pourquoi effectuer le contrôle ?</h2>
          <p>
            Le contrôle des appareils de levage permet de prévenir les chutes de charge
            dues à la rupture d’un câble, au relâchement d’un frein ou à une mauvaise
            manœuvre. Il garantit la sécurité du personnel, la préservation des biens
            matériels et la disponibilité des équipements pour une productivité optimale.
          </p>

          <div className="prs-columns">
            <article>
              <h3>Textes réglementaires applicables</h3>
              <ul>
                <li>Arrêté du 9 septembre 1953</li>
                <li>Code du travail</li>
                <li>Arrêtés et circulaires ministériels</li>
              </ul>
            </article>

            <article>
              <h3>Autorités compétentes</h3>
              <p>
                <strong>Ministère de l’Emploi</strong> — chargé de la mise en œuvre et
                du contrôle de la réglementation.
              </p>
            </article>
          </div>

          <article>
            <h3>Appareils concernés</h3>
            <p>
              Grues, chariots élévateurs, camions-grues, nacelles, ponts roulants, palans
              manuels ou électriques, treuils, crics à crémaillère, etc.
            </p>
          </article>

          <article>
            <h3>Obligations réglementaires</h3>
            <ul>
              <li>
                <strong>Essais statiques et dynamiques obligatoires</strong> avant la première mise
                en service, après remontage ou modification importante :
                <ul className="sublist">
                  <li>≤ 5 tonnes : +33 % statique / +10 % dynamique</li>
                  <li>&gt; 5 tonnes : +50 % statique / +20 % dynamique</li>
                  <li>Grues : +33 % statique / +10 % dynamique</li>
                </ul>
              </li>
              <li>
                <strong>Visites périodiques</strong> : annuelles ou semestrielles selon l’usage.
              </li>
            </ul>
          </article>

          <article>
            <h3>Documents recommandés à l’achat</h3>
            <p>
              Bien qu’aucun document ne soit exigé par la réglementation marocaine, il est
              recommandé d’obtenir :
            </p>
            <ul>
              <li>le manuel d’entretien et de sécurité ;</li>
              <li>le registre d’entretien réglementaire de l’appareil.</li>
            </ul>
          </article>

          <div className="prs-team">
            <h3>Nos moyens humains</h3>
            <p>
              Une équipe composée de <strong>4 ingénieurs</strong> et
              <strong> 12 techniciens supérieurs agréés</strong>,
             
            </p>

            <h3>Agrément</h3>
            <p>
              <strong>VERATRACT-SAFETY</strong> est agréé par le Ministère de l’Emploi pour le contrôle des
              appareils de levage.
            </p>
          </div>

          <div className="prs-btns">
            <Link to="/#contact" className="btn-primary">faire une consultation</Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
